import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const RevenueForecast = (props) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!operator) {
    return (
      <div className='index sales-promotions' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index sales-promotions'>
      {/* eslint-disable-next-line */}
      <h1 />
      <cl-membership-revenue-forecast
        mountpath={`/operators/${operator.id}/memberships/revenue-forecast`}
        apihost={`https://memberships.${env()}.credlock.net`}
        currency={operator.currency}
        token={token}
      />
    </div>
  )
}

export default RevenueForecast
